// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__qB4Pn","inactive":"Logo_inactive__+5mZ9"};